<template>
  <div class="header-bar">
    <div class="header-bar__user">
      <ul class="clearfix">
        <li class="header-bar__item" v-if="dropDown">
          <span class="header-bar__item_ch">{{ cityName }}</span>
        </li>
        <li class="header-bar__item" @click.stop="onToggleCity" v-else>
          <span class="header-bar__item_ch">{{ cityName }}</span>
          <i
            class="header-bar__city_normal"
            :class="flag ? 'header-bar__city_active' : ''"
          ></i>
        </li>
        <li v-if="isLogin" class="header-bar__item">
          <a :href="userCenterURL">
            <img
              v-if="false"
              src="./imgs/bell_spots.png"
              style="width: 22px; height: 22px;"
            />
            <img
              v-else
              src="./imgs/bell.png"
              style="width: 22px; height: 22px;"
            />
          </a>
        </li>
        <li class="header-bar__item" v-if="isLogin">
          <a :href="userCenterURL">
            <i class="header-bar__icon_people"></i>
            <span class="header-bar__item_ch">{{ userMobile }}</span>
          </a>
        </li>
        <li class="header-bar__item">
          <a :href="userCenterURL">
            <span class="header-bar__item_ch">{{TLang('个人中心','home')}}</span>
            <span class="header-bar__item_en">User Center</span>
          </a>
        </li>
        <li class="header-bar__item" v-if="isLogin">
          <a :href="logoutURL">
            <span class="header-bar__item_ch">{{TLang('退出账号','home')}}</span>
            <span class="header-bar__item_en">Sign Out</span>
          </a>
        </li>
      </ul>
    </div>
    <def-city
      :allCities="allCities"
      :hotCities="hotCities"
      @onHideCity="onHideCity"
      top="28px"
      v-show="flag"
    />
  </div>
</template>

<script>
import { getCookie } from "@/utils";
export default {
  components: {
    DefCity: () => import("./DefCity")
  },
  props: {
    unionHead: {
      type: Object,
      default: () => null
    },
    loginData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      allCities: [],
      hotCities: [],
      cityName: "",
      flag: false,
      dropDown: false,
      df_langFlag: getCookie('df_lang') && getCookie('df_lang') == 'en-US',
    };
  },
  computed: {
    userMobile() {
      const { loginUserMobile } = this.loginData;
      return loginUserMobile;
    },
    userCenterURL() {
      const { userCenter } = this.unionHead;
      return userCenter;
    },
    logoutURL() {
      const { logoutUrl } = this.loginData;
      return logoutUrl;
    },
    isLogin() {
      const { loginFlag } = this.loginData;
      return loginFlag;
    }
  },
  created() {
    // 获取城市数据
    this.getCityData();
  },
  mounted() {
    document.addEventListener("click", this.onHideCity);
    this.$bus.$on("changeCity", this.onToggleCity);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onHideCity);
    this.$bus.$off("changeCity", this.onToggleCity);
  },
  watch: {
    $route(newVal, oldVal) {
      const arr = ["packageDetails", "OrganDetails", "detail", "orderconfirm"];
      if (oldVal.query.city && oldVal.query.city !== newVal.query.city) {
        this.getCityData();
      }

      this.dropDown = arr.includes(newVal.name);
    }
  },
  methods: {
    getCityData() {
      this.apis.headerApi.getCityData().then(res => {
        this.allCities = res.cityList;
        this.hotCities = res.hotCities;
        if (!this.CheckCN()) {
          this.cityName = res.cityPinyin;
        } else {
          this.cityName = res.cityName;
        };
      });
    },
    onToggleCity() {
      this.flag = !this.flag;
    },
    onHideCity() {
      this.flag = false;
    }
  }
};
</script>

<style lang="less" scoped>
.header-bar {
  position: relative;
  z-index: 1;
  height: 28px;
  line-height: 28px;
  min-width: 1200px;
  .wrapper();
  &__user {
    text-align: right;
    height: 28px;
    > ul {
      display: inline-block;
    }
  }
  &__item {
    float: left;
    color: #1c4a9c;
    margin-left: 15px;
    font-size: 14px;
    > a {
      color: #1c4a9c;
    }
    &_en:before {
      content: "/";
      position: relative;
      top: -1px;
      padding: 0 1px;
    }
  }
  &__city {
    &_normal {
      position: relative;
      top: 1px;
      display: inline-block;
      vertical-align: middle;
      width: 0;
      height: 0;
      line-height: 0;
      font-size: 0;
      border-width: 4px;
      border-style: solid;
      border-color: #1c4a9c transparent transparent;
      transition: all 0.3s ease-in-out;
      margin-left: 3px;
    }
    &_active {
      transform: rotate(180deg) translateY(50%);
    }
  }
}
</style>
